module.exports = __webpack_public_path__ + "static/media/Blue-icon.9a8d3673.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/start/Blue-icon.svg
// module id = 1140
// module chunks = 0